import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const routes = {
  path: '/',
  resolveLocationInParallelToPagePreload: true,
  exact: true,
  enableLooseEtag: true,
  page: getLoadablePage(() => import(/* webpackChunkName: "home_page" */ '../pages/home/home')),
  chunkName: 'home_page',
};
